import { useEffect, useState } from "react";
import { ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

// Server-searched picker for customers/items
export const SearchPicker = ({ endpoint, label, placeholder, onSelect, render, testid, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);

  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => api.get(endpoint, { params: { q, limit: 50 } }).then((r) => setRows(r.data.slice(0, 50))), 200);
    return () => clearTimeout(t);
  }, [q, open, endpoint]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" className={`justify-between font-normal ${className}`} data-testid={testid}>
          <span className="truncate">{label}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[min(420px,calc(100vw-2rem))] p-0" align="start">
        <Command shouldFilter={false}>
          <CommandInput placeholder={placeholder} value={q} onValueChange={setQ} data-testid={`${testid}-search`} />
          <CommandList>
            <CommandEmpty>No results.</CommandEmpty>
            {rows.map((r) => (
              <CommandItem key={r.id} value={r.id} onSelect={() => { onSelect(r); setOpen(false); setQ(""); }} data-testid={`${testid}-option-${r.id}`}>
                {render(r)}
              </CommandItem>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
